import { TextField, Stack, Box, Typography } from "@mui/material";
import { FunctionComponent as F, useState, useEffect } from "react";
import { deletePostRefComment, getSpielComments, postNewPostRefComment } from "../../core/http/ref";
import { validateComment } from "../../utils/validate";
import Button from '../UI/Button/Button';
import { useSelector } from "react-redux";
import { IState } from "../../core/store/store";
import RefsTableRowComment from "./RefsTableRowComment";
import { ISpielComment } from "../../core/types/ref";



interface IProps
{
  refId: number
}

const RefsTableRowCommentsBox: F<IProps> = (props: IProps) =>
{
  const [comments, setComments] = useState<ISpielComment[]>([]);
  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState(false);

  const user = useSelector((state: IState) => state.user);


  useEffect(() =>
  {
    getSpielComments(props.refId)
      .then(comments =>
      {
        if(!comments)
          return;

        setComments(comments);
      });
  }, []);

  function handleCommentChange(event: React.ChangeEvent<HTMLInputElement>)
  {
    const updatedComment = event.target.value;
    setComment(updatedComment);
    setCommentError(!validateComment(updatedComment));
  }

  function handleSubmit()
  {
    if(commentError)
      return;

    postNewPostRefComment(props.refId, comment)
      .then(data =>
      {
        if(!data)
          return;

        setComments(comments.concat({
          commentId: data.postRefCommentId,
          text: comment,
          time: data.time,
          editedTime: null,
          userId: Number(user.userId),
          username: String(user.username),
          votes: 0,
          voted: false,
          deleted: false }));

        setComment("");
      });
  }

  function handleKeyPress(event: React.KeyboardEvent<HTMLDivElement>)
  {
    if(event.key === 'Enter')
      handleSubmit();

    return false;
  }

  function handleRemoveComment(postRefCommentId: number)
  {
    setComments(comments.filter(c => c.commentId !== postRefCommentId));
    deletePostRefComment(postRefCommentId);
  }

  function handleEditCommentText(postRefCommentId: number, text: string)
  {
    const comment = comments.find(c => c.commentId === postRefCommentId);
    if(!comment)
      return;

    setComments(comments.filter(c => c.commentId !== postRefCommentId).concat({
      ...comment,
      text,
      editedTime: new Date() }).sort((a, b) => a.time?.getTime() - b.time.getTime()));
  }

  return (
    <Stack sx={{ padding: 1, width: 300, outlineStyle: 'solid', outlineColor: '#EBEDEF', outlineWidth: 1 }}>
      <Box sx={{ pb: 1, mt: 'auto', overflow: 'none' }}>
        {comments.filter(c => !c.deleted).map((c, i) =>
          <RefsTableRowComment
            key={i}
            comment={c}
            handleRemove={handleRemoveComment}
            handleEdit={handleEditCommentText}/>)}
      </Box>
      {user.username ?
        <Stack direction={'row'} key={comments.length} sx={{ mt: 2 }}>
          <TextField
            variant='standard'
            sx={{ color: commentError ? 'red' : 'black' }}
            inputProps={{ style: { fontSize: 14 } }}
            fullWidth
            size='small'
            placeholder='Leave a comment'
            value={comment}
            onChange={handleCommentChange}
            onKeyPress={handleKeyPress}
            error={commentError}/>
          <Button onClick={handleSubmit} label='Submit'/>
        </Stack> :
        <Typography variant='body2'>
          Please log in to comment.
        </Typography>}

    </Stack>);
};

export default RefsTableRowCommentsBox;
